module.exports = __webpack_public_path__ + "static/img/network.7798fa2d.png";